"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FixtermOffer_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/classes/FixtermOffer"));
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
const isInComparatorResolver = (currentDisplayedPriceOffer, priceOffersInComparator) => {
    const inquiryTypeKey = currentDisplayedPriceOffer.inquiryType;
    if (currentDisplayedPriceOffer && priceOffersInComparator[inquiryTypeKey]) {
        if (currentDisplayedPriceOffer instanceof FixtermOffer_1.default) {
            const fixtermOffer = priceOffersInComparator[PageHelper_1.InquiryOfferTypesEnum.FIXTERM];
            const contractLengthKey = currentDisplayedPriceOffer.contractLength;
            if (fixtermOffer) {
                const offerId = fixtermOffer[contractLengthKey];
                return offerId === currentDisplayedPriceOffer.priceOfferId;
            }
        }
        return priceOffersInComparator[inquiryTypeKey] === currentDisplayedPriceOffer.priceOfferId;
    }
    return false;
};
exports.default = isInComparatorResolver;
